export const setPageSizeScreenWise = (isLargeScreen, isMediumScreen) => {
  if (isLargeScreen) {
    return 30;
  }
  if (isMediumScreen) {
    console.log("page Medium screen event");
    return 28;
  }
};
